'use strict';

function queryParamsController($location, $window) {
  'ngInject';

  const vm = {};

  vm.getParam = function (k, d, t) {
    const v = $location.search()[k];
    if (v === undefined) {
      return d;
    }
    if (t === 'int') {
      return parseInt(v);
    }
    if (t === 'float') {
      return parseFloat(v);
    }
    return v;
  }

  vm.setParam = function (k, v) {
    $location.replace();
    $location.search(k, v);
  }

  return vm;
}

export default queryParamsController;
